import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AzureAuthService } from '@service/project-settings/azure-login.service';

@Component({
    selector: 'app-azure-login-prompt',
    templateUrl: './azure-login-prompt.component.html',
    styleUrls: ['./azure-login-prompt.component.scss'],
    standalone: false
})
export class AzureLoginPromptComponent {
    constructor(
        public dialogRef: MatDialogRef<AzureLoginPromptComponent>,
        private azureAuthService: AzureAuthService,
    ) {}

    onNoClick(): void {
        this.dialogRef.close();
    }

    onContinue() {
        this.dialogRef.close();
        this.azureAuthService.azureLogIn();
    }
}
